import React, { Component, Fragment } from 'react';
import { reduxForm, Field } from 'redux-form';
import TextInput from '../../../app/common/Form/TextInput';
import { Button, Form, Grid } from 'semantic-ui-react';
import { isMobile, isTablet } from 'react-device-detect';
import { combineValidators, composeValidators, isRequired } from 'revalidate';
import { toastr } from 'react-redux-toastr';

const validate = combineValidators({
    withdraw_amount: composeValidators(
        isRequired({ message: 'Amount is required' }),
    )(),
});

const messageStyle = {
    fontSize: '12px',
    lineHeight: '1',
    marginBottom: '20px',
    fontStyle: "italic",
    color: "#999"
  };

class EnterAmount extends Component {
    state = {
        amount: 0
    };

    // Handle Input change for Enter amount
    handleChange = evt => {
        const trg = evt.target;

        this.setState({
            amount: trg.value
        });
    }

    /**
     * func: parseBalances
     * @description parse given stirng balances into floating values
     * amount STRING
     * payment OBJECT
     * @returns OBJECT
     */
    parseBalances = (amount, payment) => {

        const { minWithdrawableBalance, withdrawLimit  } = payment && payment.balance;

        return {
            minWithdrawableBalance: parseFloat(minWithdrawableBalance),
            withdrawLimit: parseFloat(withdrawLimit),
            amount: parseFloat(amount)
        }
    }


    // Handle Form Submit for Enter amount
    submit = values => {
        const { withdraw_amount } = values;
        const { auth, getWithdrawFeeDetails, payment } = this.props;
        const { minWithdrawableBalance, withdrawLimit, amount} = this.parseBalances(withdraw_amount, payment);

        // check entered amount
        if (amount < minWithdrawableBalance) {
            toastr.error('Withdraw money', `Amount entered is less than minimum withdrawable amount ${minWithdrawableBalance}`);
        } else if (amount > withdrawLimit) {
            toastr.error('Withdraw money', `Amount entered is greater than withdrawable amount ${withdrawLimit}`);
        } else if (typeof getWithdrawFeeDetails === 'function') {
            // Get withdraw fee details for next step
            getWithdrawFeeDetails(auth.csrfRequestIdentifier, amount);
        }
    }

    render() {
        const { async, handleSubmit, payment } = this.props;

        const withdrawableMessage = payment &&
                                    payment.balance &&
                                    payment.balance.balanceLimitReasons &&
                                    payment.balance.balanceLimitReasons.WITHDRAWABLE_BALANCE &&
                                    payment.balance.balanceLimitReasons.WITHDRAWABLE_BALANCE.WITHDRAW_MESSAGE;

        return (
            <Fragment>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Form
                                onSubmit={handleSubmit(this.submit)}
                                loading={async.key === 'getWithdrawFeeDetails' && async.loading}
                            >
                                <Field
                                    name="withdraw_amount"
                                    wrapperClassName="withdraw-text-field"
                                    maxLength={10}
                                    placeholder="ENTER AMOUNT"
                                    type="tel"
                                    allowonlynumber="true"
                                    component={TextInput}
                                    autoComplete="off"
                                    onChange={this.handleChange}
                                />

                                {
                                    withdrawableMessage &&
                                    <p
                                        style={messageStyle}>{withdrawableMessage}.&nbsp;
                                            <a
                                                href="https://support.freecharge.in/freecharge-wallet-related/how-do-i-withdraw-money-from-my-account"
                                                target="_amountLimit321"
                                            >Why?</a>
                                    </p>
                                }

                                <Button
                                    className={`fcbtn fcprimary ${
                                        isMobile || isTablet ? 'mobileandtab' : ''
                                        }`}
                                    type="submit"
                                >
                                    SUBMIT
                                </Button>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Fragment>
        )
    }
}

export default reduxForm({ form: 'withdrawmoneyForm', enableReinitialize: true, validate })(
    EnterAmount
)
